import React, { useEffect, useState } from 'react';

const BLOG_ID = '1429724877290448836';
const POST_ID = '2189482193766281495';
const API_KEY = 'AIzaSyBEm9DmGZERjuxJaLDSmNAEpPGOEqSs1JQ';
const CLIENT_ID = '472599993631-23k0fpdh3l8k3g3gkdegsku2jfr9ru7v.apps.googleusercontent.com';

const BlogTitle = () => {
  const [post, setPost] = useState(null);
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState({
    gapi: true,
    post: true,
    update: false
  });
  const [message, setMessage] = useState({ text: '', type: '' });
  const [error, setError] = useState(null);
  const [isSignedIn, setIsSignedIn] = useState(false);

  // Convert HTML to plain text
  const htmlToPlainText = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  };

  // Convert plain text to basic HTML
  const plainTextToHtml = (text) => {
    return text
      .replace(/\n/g, '<br>')
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>');
  };

  // Load Google API client
  useEffect(() => {
    const loadGoogleAPI = () => {
      return new Promise((resolve, reject) => {
        if (window.gapi) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://apis.google.com/js/api.js';
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Google API script'));
        document.body.appendChild(script);
      });
    };

    const initializeGapi = async () => {
      try {
        await loadGoogleAPI();
        
        await new Promise((resolve, reject) => {
          window.gapi.load('client:auth2', {
            callback: async () => {
              try {
                await window.gapi.client.init({
                  apiKey: API_KEY,
                  clientId: CLIENT_ID,
                  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/blogger/v3/rest'],
                  scope: 'https://www.googleapis.com/auth/blogger',
                  redirect_uri: window.location.origin
                });
                resolve();
              } catch (err) {
                reject(err);
              }
            },
            onerror: () => reject(new Error('Failed to load Google API client')),
            timeout: 10000,
            ontimeout: () => reject(new Error('Google API client loading timed out'))
          });
        });

        window.gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
        updateSigninStatus(window.gapi.auth2.getAuthInstance().isSignedIn.get());
        setLoading(prev => ({ ...prev, gapi: false }));
      } catch (err) {
        console.error('Initialization error:', err);
        setError(err.message);
        setLoading(prev => ({ ...prev, gapi: false }));
      }
    };

    const fetchPost = async () => {
      try {
        setLoading(prev => ({ ...prev, post: true }));
        const response = await fetch(
          `https://www.googleapis.com/blogger/v3/blogs/${BLOG_ID}/posts/${POST_ID}?key=${API_KEY}`
        );
        
        if (!response.ok) throw new Error('Failed to fetch blog post');

        const data = await response.json();
        setPost(data);
        setTitle(data.title);
        setContent(htmlToPlainText(data.content));
      } catch (err) {
        console.error('Error fetching post:', err);
        setError(err.message);
      } finally {
        setLoading(prev => ({ ...prev, post: false }));
      }
    };

    initializeGapi();
    fetchPost();

    return () => {
      // Cleanup if needed
    };
  }, []);

  const updateSigninStatus = (isSignedIn) => {
    setIsSignedIn(isSignedIn);
  };

  const handleAuthClick = () => {
    if (isSignedIn) {
      window.gapi.auth2.getAuthInstance().signOut();
    } else {
      window.gapi.auth2.getAuthInstance().signIn()
        .catch(err => {
          console.error('Sign-in error:', err);
          setMessage({ text: `Sign-in failed: ${err.error}`, type: 'error' });
        });
    }
  };

  const handleUpdate = async () => {
    try {
      if (!isSignedIn) {
        handleAuthClick();
        setMessage({ text: 'Please sign in first', type: 'error' });
        return;
      }

      setLoading(prev => ({ ...prev, update: true }));
      setMessage({ text: 'Updating post...', type: 'info' });

      const htmlContent = plainTextToHtml(content);

      const response = await window.gapi.client.blogger.posts.update({
        blogId: BLOG_ID,
        postId: POST_ID,
        resource: {
          title,
          content: htmlContent
        }
      });

      setPost(response.result);
      setMessage({ text: 'Post updated successfully!', type: 'success' });
    } catch (err) {
      console.error('Error updating post:', err);
      setMessage({ 
        text: `Error: ${err.result?.error?.message || err.message}`,
        type: 'error' 
      });
    } finally {
      setLoading(prev => ({ ...prev, update: false }));
    }
  };

  if (loading.gapi) {
    return (
      <div style={styles.container}>
        <h2>Loading Google API...</h2>
        <p>Please wait while we load the necessary Google services.</p>
        {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <h2>Error</h2>
        <p style={{ color: 'red' }}>{error}</p>
        <button 
          onClick={() => window.location.reload()} 
          style={styles.button}
        >
          Refresh Page
        </button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h2>Edit Blog Post</h2>

      <button 
        onClick={handleAuthClick} 
        style={styles.authButton}
        disabled={loading.post || loading.update}
      >
        {isSignedIn ? 'Sign Out' : 'Sign In with Google'}
      </button>

      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={styles.input}
        placeholder="Post Title"
        disabled={!isSignedIn || loading.update}
      />

      <textarea
        rows={15}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        style={styles.textarea}
        placeholder="Write your blog post content here (plain text)..."
        disabled={!isSignedIn || loading.update}
      />

      <button 
        onClick={handleUpdate} 
        style={{ ...styles.button, ...styles.updateButton }}
        disabled={!isSignedIn || loading.update}
      >
        {loading.update ? 'Updating...' : 'Update Blog Post'}
      </button>

      {message.text && (
        <p style={{
          color: message.type === 'error' ? '#dc3545' : 
                message.type === 'success' ? '#28a745' : '#ffc107',
          padding: '10px',
          borderRadius: '4px',
          backgroundColor: message.type === 'error' ? '#f8d7da' : 
                          message.type === 'success' ? '#d4edda' : '#fff3cd'
        }}>
          {message.text}
        </p>
      )}

      <div style={styles.helpText}>
        <p><strong>Formatting tips:</strong></p>
        <ul>
          <li>Press Enter for new paragraphs</li>
          <li>**bold text** for bold</li>
          <li>*italic text* for italic</li>
        </ul>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    fontFamily: 'Arial, sans-serif',
    padding: '30px',
    background: '#fff',
    borderRadius: '10px',
    boxShadow: '0 2px 20px rgba(0,0,0,0.1)',
  },
  authButton: {
    padding: '10px 15px',
    backgroundColor: '#4285F4',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginBottom: '20px'
  },
  input: {
    width: '100%',
    padding: '12px 15px',
    marginBottom: '20px',
    fontSize: '1.2em',
    border: '1px solid #ddd',
    borderRadius: '6px'
  },
  textarea: {
    width: '100%',
    padding: '15px',
    fontSize: '1em',
    marginBottom: '20px',
    minHeight: '300px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    lineHeight: '1.6',
    whiteSpace: 'pre-wrap'
  },
  button: {
    padding: '12px 25px',
    fontSize: '1em',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  updateButton: {
    backgroundColor: '#4CAF50',
  },
  helpText: {
    marginTop: '20px',
    padding: '15px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px'
  }
};

export default BlogTitle;